"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var queryablesecurable_1 = require("./queryablesecurable");
var folders_1 = require("./folders");
var contenttypes_1 = require("./contenttypes");
var util_1 = require("../../utils/util");
var odata_1 = require("./odata");
var Items = (function (_super) {
    __extends(Items, _super);
    function Items(baseUrl, path) {
        if (path === void 0) { path = "items"; }
        _super.call(this, baseUrl, path);
    }
    Items.prototype.getById = function (id) {
        var i = new Item(this);
        i.concat("(" + id + ")");
        return i;
    };
    Items.prototype.skip = function (skip) {
        this._query.add("$skiptoken", encodeURIComponent("Paged=TRUE&p_ID=" + skip));
        return this;
    };
    Items.prototype.getPaged = function () {
        return this.getAs(new PagedItemCollectionParser());
    };
    Items.prototype.add = function (properties) {
        var _this = this;
        if (properties === void 0) { properties = {}; }
        var removeDependency = this.addBatchDependency();
        var parentList = this.getParent(queryable_1.QueryableInstance);
        return parentList.select("ListItemEntityTypeFullName").getAs().then(function (d) {
            var postBody = JSON.stringify(util_1.Util.extend({
                "__metadata": { "type": d.ListItemEntityTypeFullName },
            }, properties));
            var promise = _this.postAs({ body: postBody }).then(function (data) {
                return {
                    data: data,
                    item: _this.getById(data.Id),
                };
            });
            removeDependency();
            return promise;
        });
    };
    return Items;
}(queryable_1.QueryableCollection));
exports.Items = Items;
var Item = (function (_super) {
    __extends(Item, _super);
    function Item(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(Item.prototype, "attachmentFiles", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "AttachmentFiles");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "contentType", {
        get: function () {
            return new contenttypes_1.ContentType(this, "ContentType");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "effectiveBasePermissions", {
        get: function () {
            return new queryable_1.Queryable(this, "EffectiveBasePermissions");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "effectiveBasePermissionsForUI", {
        get: function () {
            return new queryable_1.Queryable(this, "EffectiveBasePermissionsForUI");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "fieldValuesAsHTML", {
        get: function () {
            return new queryable_1.QueryableInstance(this, "FieldValuesAsHTML");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "fieldValuesAsText", {
        get: function () {
            return new queryable_1.QueryableInstance(this, "FieldValuesAsText");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "fieldValuesForEdit", {
        get: function () {
            return new queryable_1.QueryableInstance(this, "FieldValuesForEdit");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "folder", {
        get: function () {
            return new folders_1.Folder(this, "Folder");
        },
        enumerable: true,
        configurable: true
    });
    Item.prototype.update = function (properties, eTag) {
        var _this = this;
        if (eTag === void 0) { eTag = "*"; }
        var removeDependency = this.addBatchDependency();
        var parentList = this.getParent(queryable_1.QueryableInstance, this.parentUrl.substr(0, this.parentUrl.lastIndexOf("/")));
        return parentList.select("ListItemEntityTypeFullName").getAs().then(function (d) {
            var postBody = JSON.stringify(util_1.Util.extend({
                "__metadata": { "type": d.ListItemEntityTypeFullName },
            }, properties));
            var promise = _this.post({
                body: postBody,
                headers: {
                    "IF-Match": eTag,
                    "X-HTTP-Method": "MERGE",
                },
            }).then(function (data) {
                return {
                    data: data,
                    item: _this,
                };
            });
            removeDependency();
            return promise;
        });
    };
    Item.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.post({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    Item.prototype.recycle = function () {
        var i = new Item(this, "recycle");
        return i.post();
    };
    Item.prototype.getWopiFrameUrl = function (action) {
        if (action === void 0) { action = 0; }
        var i = new Item(this, "getWOPIFrameUrl(@action)");
        i._query.add("@action", action);
        return i.post().then(function (data) {
            return data.GetWOPIFrameUrl;
        });
    };
    Item.prototype.validateUpdateListItem = function (formValues, newDocumentUpdate) {
        if (newDocumentUpdate === void 0) { newDocumentUpdate = false; }
        var postBody = JSON.stringify({ "formValues": formValues, bNewDocumentUpdate: newDocumentUpdate });
        var item = new Item(this, "validateupdatelistitem");
        return item.post({ body: postBody });
    };
    return Item;
}(queryablesecurable_1.QueryableSecurable));
exports.Item = Item;
var PagedItemCollection = (function () {
    function PagedItemCollection(nextUrl, results) {
        this.nextUrl = nextUrl;
        this.results = results;
    }
    Object.defineProperty(PagedItemCollection.prototype, "hasNext", {
        get: function () {
            return typeof this.nextUrl === "string" && this.nextUrl.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    PagedItemCollection.prototype.getNext = function () {
        if (this.hasNext) {
            var items = new Items(this.nextUrl, null);
            return items.getPaged();
        }
        return new Promise(function (r) { return r(null); });
    };
    return PagedItemCollection;
}());
exports.PagedItemCollection = PagedItemCollection;
var PagedItemCollectionParser = (function (_super) {
    __extends(PagedItemCollectionParser, _super);
    function PagedItemCollectionParser() {
        _super.apply(this, arguments);
    }
    PagedItemCollectionParser.prototype.parse = function (r) {
        var _this = this;
        return r.json().then(function (json) {
            var nextUrl = json.hasOwnProperty("d") && json.d.hasOwnProperty("__next") ? json.d.__next : json["odata.nextLink"];
            return new PagedItemCollection(nextUrl, _this.parseODataJSON(json));
        });
    };
    return PagedItemCollectionParser;
}(odata_1.ODataParserBase));
